export default {
  fields: {
    price: 'Prix',
    tax: 'Taxe',
    visible_to: 'Visible par',
  },
  buttons: {
    add_price: '+ Ajouter un prix',
  },
};
